import React from 'react';

const User = () => (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5998 21.3V20.4998C6.5998 17.8489 8.74884 15.7 11.3998 15.7H14.5998C17.2508 15.7 19.3998 17.8489 19.3998 20.4998V21.3M12.9998 6.10005C11.2325 6.10005 9.7998 7.53274 9.7998 9.30005C9.7998 11.0674 11.2325 12.5 12.9998 12.5C14.7671 12.5 16.1998 11.0674 16.1998 9.30005C16.1998 7.53274 14.7671 6.10005 12.9998 6.10005ZM12.9998 23.7C6.81422 23.7 1.7998 18.6856 1.7998 12.5C1.7998 6.31446 6.81422 1.30005 12.9998 1.30005C19.1854 1.30005 24.1998 6.31446 24.1998 12.5C24.1998 18.6856 19.1854 23.7 12.9998 23.7Z"
      stroke={"currentColor"}
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

export default User;
